var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconAccessibility128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_9384)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 14.2236C91.4922 14.2236 113.779 36.5105 113.779 64.0027C113.779 91.4949 91.4922 113.782 64 113.782C36.5078 113.782 14.2209 91.4949 14.2209 64.0027C14.2209 36.5105 36.5078 14.2236 64 14.2236ZM40.6769 44.0911C38.3834 44.0911 36.5241 45.9329 36.5241 48.2046C36.5241 50.7806 38.4861 52.9416 41.0723 53.2142L53.7176 54.547H55.5692V71.5873L48.3421 95.0008C47.6587 97.2148 48.9167 99.5583 51.152 100.235C53.3873 100.912 55.7533 99.666 56.4367 97.452L63.8576 73.4106H64.3957L71.8166 97.452C72.5 99.666 74.866 100.912 77.1012 100.235C79.3365 99.5583 80.5946 97.2148 79.9112 95.0008L72.4981 70.9846V54.547H74.3497L86.9949 53.2142C89.5811 52.9416 91.5431 50.7806 91.5431 48.2046C91.5431 48.0723 91.5367 47.9401 91.5238 47.8085C91.303 45.5474 89.2733 43.8917 86.9905 44.1105L72.6303 45.4864H55.4369L41.0767 44.1105C40.9438 44.0977 40.8104 44.0911 40.6769 44.0911ZM64.0336 28.732C60.5275 28.732 57.6853 31.5472 57.6853 35.0199C57.6853 38.4926 60.5275 41.3078 64.0336 41.3078C67.5397 41.3078 70.382 38.4926 70.382 35.0199C70.382 31.5472 67.5397 28.732 64.0336 28.732Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0334 41.3078C67.5395 41.3078 70.3817 38.4926 70.3817 35.0199C70.3817 31.5472 67.5395 28.732 64.0334 28.732C60.5273 28.732 57.6851 31.5472 57.6851 35.0199C57.6851 38.4926 60.5273 41.3078 64.0334 41.3078Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3955 73.4106H63.8574L56.4365 97.452C55.7531 99.666 53.3871 100.912 51.1518 100.235C48.9165 99.5583 47.6585 97.2148 48.3419 95.0008L55.569 71.5873V54.547H53.7174L41.0721 53.2142C38.4859 52.9416 36.5239 50.7806 36.5239 48.2046C36.5239 45.9329 38.3832 44.0911 40.6767 44.0911C40.8102 44.0911 40.9436 44.0977 41.0765 44.1105L55.4367 45.4864H72.6301L86.9903 44.1105C89.2731 43.8917 91.3028 45.5474 91.5236 47.8085C91.5365 47.9401 91.5429 48.0723 91.5429 48.2046C91.5429 50.7806 89.5809 52.9416 86.9947 53.2142L74.3495 54.547H72.4979V70.9846L79.911 95.0008C80.5944 97.2148 79.3363 99.5583 77.1011 100.235C74.8658 100.912 72.4998 99.666 71.8164 97.452L64.3955 73.4106Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_9384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconAccessibility128);
export default __webpack_public_path__ + "static/media/pictogramBeaconAccessibility128.19e13cb446c8bbdd9560ff8188f017da.svg";
export { ForwardRef as ReactComponent };